import React from 'react';
import { Shield, Award, Users } from 'lucide-react';
import { content } from '../data/content';
export function TrustBar() {
  const icons = [Shield, Award, Users];
  return <div className="bg-brand-cream py-6 border-b border-brand-tan/20" data-id="element-253">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 lg:gap-24" data-id="element-255">
          {content.trustBar.map((point, index) => {
          const Icon = icons[index];
          return <div key={index} className="flex items-center text-brand-brown font-medium text-sm md:text-base" data-id="element-256">
                <Icon className="w-6 h-6 mr-3 text-brand-orange" data-id="element-257" />
                <span data-id="element-258">{point}</span>
              </div>;
        })}
        </div>
      </div>
    </div>;
}